import TrackingPixel from './TrackingPixel';

export default TrackingPixel;
